/**
 * EICR - PDF Transform
 */
import { computeOverallAssessment } from '../../utils/electrical/eicrClassification.js';

export const transformForPDF = (formData) => {
  // Compute overall assessment
  const codes = (formData.observations || [])
    .map(o => o.observationCode)
    .filter(Boolean);
  const outcome = computeOverallAssessment(codes);

  const observations = (formData.observations || []).map(obs => ({
    code: obs.observationCode || '',
    details: obs.observationDetails || '',
    location: obs.observationLocation || '',
    photo: obs.photo || '',
    limitations: obs.limitations || 'None'
  }));

  return {
    title: 'ELECTRICAL INSTALLATION CONDITION REPORT',
    standard: 'BS 7671:2018+A2:2022 (IET Wiring Regulations 18th Edition)',
    reportDetails: {
      reportNumber: formData.reportDetails?.reportNumber || '',
      reportDate: formData.reportDetails?.reportDate || '',
      purposeOfReport: formData.reportDetails?.purposeOfReport || '',
      inspectionType: formData.reportDetails?.inspectionTypeLabel || 'Periodic Inspection'
    },
    client: {
      name: formData.client?.clientName || '',
      address: formData.client?.clientAddress || ''
    },
    property: {
      address: formData.property?.propertyAddress || '',
      type: formData.property?.propertyType || '',
      bedrooms: formData.property?.numberOfBedrooms || '',
      age: formData.property?.estimatedAgeOfInstallation || ''
    },
    installation: {
      address: formData.installation?.installationAddress || '',
      extentLimitations: formData.installation?.extentLimitations || '',
      mainSupply: formData.installation?.mainSupply || '',
      earthingArrangement: formData.installation?.earthingArrangement || '',
      externalZe: formData.installation?.externalZe || ''
    },
    distributionBoards: formData.distributionBoards || [],
    circuits: formData.circuits || [],
    observations,
    recommendation: {
      summaryCondition: formData.recommendation?.summaryCondition || '',
      recommendations: formData.recommendation?.recommendations || ''
    },
    overallAssessment: outcome.overallAssessment,
    forceReason: outcome.forceReason,
    declaration: {
      engineerName: formData.declaration?.engineerName || '',
      engineerCardNumber: formData.declaration?.engineerCardNumber || '',
      companyName: formData.declaration?.companyName || '',
      engineerSignature: formData.declaration?.engineerSignature || '',
      clientSignature: formData.declaration?.clientSignature || ''
    }
  };
};

export default transformForPDF;